<template>
<el-dialog class="dialog-mini" v-el-drag-dialog :title="'快速查询'" width="50%" :visible.sync="visible" @close="handleCancel">
  <div style="height: calc(60vh)">
    <el-form class="form-container"  ref="dataForm" label-position="right">
      <div style="height: calc(60vh - 68px)">
          <el-table border
                     show-overflow
                     ref="xTable"
                     height="100%"
                     class="editable-footer"
                     :loading="loading"
                     :data="tabledata">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="description" min-width="160" label="名称" >
              <template slot-scope="scope">
                <span>
                  {{scope.row.description}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="relation" min-width="160" label="条件">
              <template slot-scope="scope">
                 <el-select size="small"  v-model="scope.row.relation" @change="selchange(scope.row,$event)">
                  <el-option v-for="(item, index) in scope.row.selArray" :key="index" :value="item.value" :label="item.name"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="firstValue" min-width="260" label="值">
              <template slot-scope="scope">
                <el-date-picker v-if="scope.row.formType==='DatePicker'" v-model="scope.row.firstValue" value-format="yyyy-MM-dd" type="daterange" unlink-panels  start-placeholder="开始日期" end-placeholder="结束日期" size="small"></el-date-picker>
                <el-date-picker v-else-if="scope.row.formType==='DateTimePicker'" v-model="scope.row.firstValue" value-format="yyyy-MM-dd" type="daterange" unlink-panels  start-placeholder="开始日期" end-placeholder="结束日期" size="small"></el-date-picker>
                <el-input-number v-else-if="scope.row.formType==='InputNumber'" v-model="scope.row.firstValue" maxlength="9" controls-position="right" :precision="2" :step="0.1"></el-input-number>
                <select-type ref="selectType" :isEdit="true" :typeId="scope.row.isSel" v-model="scope.row.firstValue" v-else-if="scope.row.formType==='Select' && scope.row.isSel !== ''">
                </select-type>
                <el-switch v-else-if="scope.row.formType==='Switch'" v-model="scope.row.firstValue" :active-value="true" :inactive-value="false"></el-switch>
                   <auto-new  v-else-if="scope.row.formType==='AutoNew' && scope.row.isSel !== ''"
                    :id.sync="scope.row.firstValue"
                    :name.sync="scope.row.secondValue"
                    :idKey="'id'"
                    :nameKey="'name'"
                    :apiName="scope.row.isSel"
                    ></auto-new>
                <el-input v-else v-model="scope.row.firstValue" size="small"></el-input>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <el-row>
        <el-col :span="24">
          <div style="float: right; margin: 20px;">
            <el-button size="mini" @click="handleCancel">取消</el-button>
            <el-button size="mini"  type="primary" @click="handleConfirm">确认</el-button>
          </div>
        </el-col>
      </el-row>

    </el-form>

  </div>
</el-dialog>
</template>

<script>
import waves from '@/directive/waves'; // 水波纹指令
import elDragDialog from '@/directive/el-dragDialog';
import SelectType from '@/components/SelectType';
import autoNew from '@/components/AutoNew';
import * as sysfields from '@/api/sysfields';

export default {
  name: 'query-page',
  components: {
    SelectType,
    autoNew
  },
  directives: {
    waves,
    elDragDialog
  },
  props: {
    code: {
      type: String,
      default() {
        return '';
      }
    },
    changeData: {
      type: Array,
      default() {
        return [];
      }
    },
    dialogVisible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() { // todo:兼容layui的样式、图标
    return {
      tabledata: [],
      loading: false,
      visible: false
    };
  },
  watch: {
    dialogVisible(val) {
      this.visible = val;
      // if (val) {
      //   this.initData()
      // }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    handleCancel() {
      this.visible = false;
      this.$emit('update:dialogVisible', false);
    },
    handleConfirm() {
      const tempdata = this.tabledata.filter(m => {
        return m.firstValue !== undefined || m.firstValue !== null;
      });// 筛选空值

      let postdata = tempdata.map(function(item, index, input) {
        return {
          field: item.field, // 键名
          relation: item.relation, // 条件关系
          value: item.firstValue
        };
      });
      if (postdata.length === 0) { // 当没有填写查询条件时，则直接将查询条件赋空值，否则会报错
        postdata = [];
      }
      this.$emit('filter', postdata);
      this.handleCancel();
    },
    selchange(row, val) { // 条件下拉选择框只用于显示，若使用selecttype组件，则每次都会向后台请求查询
      row.relationNm = row.selArray.find(u => u.value === val).name;
    },
    initData() {
      this.tabledata = [];
      const typeDatas = [{
        dtCode: '<=',
        name: '小于等于'
      }, {
        dtCode: '==',
        name: '等于'
      }, {
        dtCode: '>=',
        name: '大于等于'
      }, {
        dtCode: 'betweenand',
        name: '两者之间'
      }, {
        dtCode: 'contains',
        name: '包含'
      }];
      sysfields.queryFilter(this.code).then(response => {
        let tempArray = [];
        response.result.forEach(item => { // 传给组件的值
          tempArray = [];
          item.relation = item.relation && item.relation !== '' ? item.relation.split('/') : [];// 查询条件下拉框
          item.relation.forEach(item => {
            tempArray.push({
              name: typeDatas.find(u => u.dtCode === item).name,
              value: item
            });
          });
          this.tabledata.push({ // 用于显示，传输的数据
            field: item.name, // 键名
            relation: tempArray.length > 0 ? tempArray[0].value : '', // 条件关系
            formType: item.formType, // 控件类型
            description: item.title, // 名称
            relationNm: tempArray.length > 0 ? tempArray[0].name : '', // 条件关系名称 用于显示
            selArray: tempArray, // 条件下拉框选项
            firstValue: item.value ? item.value : '',
            isSel: item.isSel ? item.isSel : '',
            secondValue: ''
          });
        });
      });
    },
    queryClear() {
      this.tabledata.forEach(item => {
        item.firstValue = '';
        item.relation = item.selArray.length > 0 ? item.selArray[0].value : '';
        item.relationNm = item.selArray.length > 0 ? item.selArray[0].name : '';
      });
    }
  }
};

</script>

<style scoped>

</style>
